import * as React from 'react';
// @ts-expect-error
import ReactTooltip from 'react-tooltip';

import classnames from 'classnames';

import {PageTitleBreadcrumbs} from './page-title-breadcrumbs';
import type {Breadcrumb} from './page-title-breadcrumbs';

import styles from './page-title-bar-title.module.css';

type Props = {
    title: string;
    titleTooltip?: boolean;
    titleComponent?: React.ReactNode;
    titleBadge?: React.ReactNode;
    subheaderPrimaryText: string | React.ReactNode;
    isModified?: boolean;
    subheaderSecondaryText?: string;
    breadcrumbsTitle?: string;
    breadcrumbs?: Breadcrumb[];
    noMaxWidth?: boolean;
    isEditable?: boolean;
    glossaryButton?: React.ReactNode;
};

export class PageTitleBarTitle extends React.Component<Props> {
    componentDidMount() {
        ReactTooltip.rebuild();
    }

    componentDidUpdate(prevProps: Props) {
        if (this.props.isModified && prevProps.isModified !== this.props.isModified) {
            ReactTooltip.rebuild();
        }
    }

    render() {
        const styleNames = classnames({
            [styles.title]: true,
            [styles['title--no-truncate']]: this.props.noMaxWidth,
            [styles['title--editable']]: this.props.isEditable,
        });

        return (
            <div className={styles['page-title-bar-title']}>
                <div className={styles['title-container']}>
                    <div className={styles['title-header-container']}>
                        <h1
                            // @ts-expect-error
                            title={this.props.titleTooltip ? this.props.title : null}
                            className={styleNames}
                        >
                            {this.props.titleComponent || this.props.title}
                            {this.props.isModified ? (
                                <span data-tip='Unsaved' className={styles.modified}>
                                    *
                                </span>
                            ) : undefined}
                        </h1>
                        {this.props.glossaryButton}
                        {this.props.titleBadge}
                    </div>
                    {this.props.breadcrumbs && this.props.breadcrumbs.length ? (
                        <PageTitleBreadcrumbs
                            title={this.props.breadcrumbsTitle || this.props.title}
                            breadcrumbs={this.props.breadcrumbs}
                        />
                    ) : (
                        <div className={styles['subheader-container']}>
                            {this.props.subheaderSecondaryText ? (
                                <h4 className={styles['subheader--secondary']}>
                                    {this.props.subheaderSecondaryText}
                                </h4>
                            ) : undefined}
                            <i>{this.props.subheaderPrimaryText}</i>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
